/* eslint-disable no-unused-expressions */


import React, { useState, useRef, useEffect } from "react";

export const SearchIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-search-icon lucide-search"
    {...props}
  >
    <path d="m21 21-4.34-4.34" />
    <circle cx={11} cy={11} r={8} />
  </svg>
);

export const XIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-x-icon lucide-x"
    {...props}
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

const AnimatedSearchBar = ({categories,searchValue,setSearchValue,filteredResults,setFilteredResults,services ,showResultDropDown=false}) => {
  const [isExpanded, setIsExpanded] = useState(false);


  const searchRef = useRef(null);
  const inputRef = useRef(null);

 

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsExpanded(false);
        setFilteredResults([]);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleSearchClick = (event) => {
    event.stopPropagation();
    setIsExpanded(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 150);
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
    setIsExpanded(false);
    setSearchValue("");
    setFilteredResults([]);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (value.trim()) {
      const matches = services.filter((service) =>
  service.name.toLowerCase().includes(value.toLowerCase())
);
      setFilteredResults(matches);
    } else {
      setFilteredResults([]);
    }
  };

  const handleSelectResult = (result) => {
    setSearchValue(result);
    setFilteredResults([]);
  };


  return (
    <div className="services-form-container" ref={searchRef}>
      <div className={`search-bar ${isExpanded ? "expanded" : "collapsed"} ${categories.length === 0 ? "no-categories" : ""}`}>
        <button onClick={handleSearchClick} className="search-button">
          <SearchIcon size={16} style={{ color: "#171F46" }} />
        </button>
        <input
          ref={inputRef}
          type="text"
          placeholder="Find a service"
          value={searchValue}
          onChange={handleInputChange}
          className="search-input"
        />
        <button onClick={handleCloseClick} className="close-button">
          <XIcon size={18} style={{ color: "#171F46" }} />
        </button>
      </div>

      {/* Results dropdown */}
      {filteredResults.length > 0 && showResultDropDown  &&(
        <div  className={`search-results ${categories.length === 0 ? "no-categories" : ""}`}>
          {filteredResults.map((result, idx) => (
            <div
              key={idx}
              className="search-result-item"
              onClick={() => handleSelectResult(result.name)}
            >
              {result.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnimatedSearchBar;


